export class CommunitySideNavigationTree {
    static communityRootItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'COMMUNITY_HOME',
            path: '/community/:communityId/home',
            icon: '',
            text: 'Community Workspace',
            tooltip: 'Community Workspace',
            items: [],
            isWorkspace: true
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_COMPLIANCE',
            path: null,
            icon: '',
            text: 'Compliance',
            tooltip: 'Compliance',
            items: [
                {
                    id: `${parentId}_2_1`,
                    parentId: `${parentId}_2`,
                    name: 'COMMUNITY_RESTRICTION_SUMMARY',
                    path: '/community/:communityId/community-restriction-summary',
                    icon: '',
                    text: 'Restriction Summary',
                    tooltip: 'Restriction Summary',
                    items: []
                },
                {
                    id: `${parentId}_2_2`,
                    parentId: `${parentId}_2`,
                    name: 'COMMUNITY_DETAILED_VIOLATION_LOG',
                    path: '/community/:communityId/violations/detailed_violation_log',
                    icon: '',
                    text: 'Detailed Violations Log',
                    tooltip: 'Detailed Violations Log',
                    items: []
                },
                {
                    id: `${parentId}_2_3`,
                    parentId: `${parentId}_2`,
                    name: 'OPEN_VIOLATIONS_LOG',
                    path: '/community/:communityId/violations/open_violations_log',
                    icon: '',
                    text: 'Open Violations Log',
                    tooltip: 'Open Violations Log',
                    items: []
                },
                {
                    id: `${parentId}_2_4`,
                    parentId: `${parentId}_2`,
                    name: 'LAST_INSPECTION_LOG',
                    path: '/community/:communityId/violations/last_inspection_log',
                    icon: '',
                    text: 'Last Inspection Log',
                    tooltip: 'Last Inspection Log',
                    items: []
                },
                {
                    id: `${parentId}_2_5`,
                    parentId: `${parentId}_2`,
                    name: 'RECORD_INITIAL_VIOLATION',
                    path: '/community/:communityId/violations/record_initial_violation',
                    icon: '',
                    text: 'Record Initial Violation',
                    tooltip: 'Record Initial Violation',
                    items: []
                },
                {
                    id: `${parentId}_2_6`,
                    parentId: `${parentId}_2`,
                    name: 'INSPECTION',
                    path: '/community/:communityId/violations/inspection_scheduler',
                    icon: '',
                    text: 'Inspection',
                    tooltip: 'Inspection',
                    items: []
                },
                {
                    id: `${parentId}_2_7`,
                    parentId: `${parentId}_2`,
                    name: 'PROPERTY_REPORT_VIOLATION',
                    path: '/community/:communityId/violations/report_violation',
                    icon: '',
                    text: 'Report a Violation',
                    tooltip: 'Report a Violation',
                    items: []
                },
                {
                    id: `${parentId}_2_8`,
                    parentId: `${parentId}_2`,
                    name: 'CERTIFIED_VIOLATION_NOTICES',
                    path: '/community/:communityId/violations/certified_tracking',
                    icon: '',
                    text: 'Certified Tracking',
                    tooltip: 'Certified Tracking',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'COMMUNITY_INFORMATION',
            path: null,
            icon: '',
            text: 'Information',
            tooltip: 'Information',
            items: [
                {
                    id: `${parentId}_3_1`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_CALENDAR',
                    path: '/community/:communityId/calendar',
                    icon: '',
                    text: 'Calendar',
                    tooltip: 'Calendar',
                    items: []
                },
                {
                    id: `${parentId}_3_2`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_DOCUMENTS',
                    path: null,
                    icon: '',
                    text: 'Documents',
                    tooltip: 'Documents',
                    items: CommunitySideNavigationTree.documentItems(`${parentId}_3_2`, ':communityId')
                },
                {
                    id: `${parentId}_3_3`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_DASHBOARD',
                    path: '/community/:communityId/dashboard',
                    icon: '',
                    text: 'Graphs & Metrics',
                    tooltip: 'Graphs & Metrics',
                    items: []
                },
                {
                    id: `${parentId}_3_4`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_INFO',
                    path: '/community/:communityId/information',
                    icon: '',
                    text: 'Info Summary',
                    tooltip: 'Info Summary',
                    items: []
                },
                {
                    id: `${parentId}_3_5`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_LEGAL_INFO',
                    path: '/community/:communityId/legal-information',
                    icon: '',
                    text: 'Legal Summary',
                    tooltip: 'Legal Summary',
                    items: []
                },
                {
                    id: `${parentId}_3_6`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_ADDITIONAL_INFO',
                    path: '/community/:communityId/additional-info',
                    icon: '',
                    text: 'Additional Info',
                    tooltip: 'Additional Info',
                    items: []
                },
                {
                    id: `${parentId}_3_7`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_MAP',
                    path: '/community/:communityId/map',
                    icon: '',
                    text: 'Map',
                    tooltip: 'Community Map',
                    items: []
                },
                {
                    id: `${parentId}_3_8`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_ENFORCEMENT_POLICY',
                    path: '/community/:communityId/enforcement-policy',
                    icon: '',
                    text: 'Enforcement Policy',
                    tooltip: 'Enforcement Policy',
                    items: []
                },
                {
                    id: `${parentId}_3_9`,
                    parentId: `${parentId}_3`,
                    name: 'COMMON_LOTS',
                    path: '/community/:communityId/common-lots',
                    icon: '',
                    text: 'Common Lots',
                    tooltip: 'Common Lots',
                    items: []
                },
                {
                    id: `${parentId}_3_10`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_NOTES',
                    path: '/community/:communityId/notes',
                    icon: '',
                    text: 'Community Notes',
                    tooltip: 'Community Notes',
                    items: []
                },
                {
                    id: `${parentId}_3_11`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_ASSETS',
                    path: '/community/:communityId/assets',
                    icon: '',
                    text: 'Community Assets',
                    tooltip: 'Community Assets',
                    items: []
                },
                {
                    id: `${parentId}_3_12`,
                    parentId: `${parentId}_3`,
                    name: 'BOARD_COMMITTEE_MEMBERS',
                    path: '/community/:communityId/board-committee-members',
                    icon: '',
                    text: 'Board / Committee Members',
                    tooltip: 'Board / Committee Members',
                    items: []
                },
                {
                    id: `${parentId}_3_13`,
                    parentId: `${parentId}_3`,
                    name: 'PROPERTY_TAX_APPRAISAL',
                    path: '/community/:communityId/property-tax-appraisal',
                    icon: '',
                    text: 'Property Tax Appraisal',
                    tooltip: 'Property Tax Appraisal',
                    items: []
                },
                {
                    id: `${parentId}_3_14`,
                    parentId: `${parentId}_3`,
                    name: 'AMENITIES_AND_ACCESS_CONTROL',
                    path: '/community/:communityId/amenities-and-access-control',
                    icon: '',
                    text: 'Amenities and Access Control',
                    tooltip: 'Amenities and Access Control',
                    items: []
                },
                {
                    id: `${parentId}_3_15`,
                    parentId: `${parentId}_3`,
                    name: 'VENDOR_MANAGEMENT',
                    path: '/community/:communityId/my-portfolio/vendor-management',
                    icon: '',
                    text: 'Vendor Management',
                    tooltip: 'Vendor Management',
                    items: []
                },
                {
                    id: `${parentId}_3_16`,
                    parentId: `${parentId}_3`,
                    name: 'INSURANCE',
                    path: '/community/:communityId/my-work/insurance',
                    icon: '',
                    text: 'Insurance',
                    tooltip: 'Community Insurance',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'COMMUNITY_COMMUNICATION',
            path: null,
            icon: '',
            text: 'Communications',
            tooltip: 'Communications',
            items: [
                {
                    id: `${parentId}_4_1`,
                    parentId: `${parentId}_4`,
                    name: 'COMMUNITY_MASS_COMMUNICATION',
                    path: '/community/:communityId/masscommunication',
                    icon: '',
                    text: 'Mass Communications',
                    tooltip: 'Mass Communications',
                    items: []
                },
                {
                    id: `${parentId}_4_2`,
                    parentId: `${parentId}_4`,
                    name: 'COMMUNITY_RESIDENT_CONTACT_LOGS',
                    path: '/community/:communityId/resident-contact-logs',
                    icon: '',
                    text: 'Resident Contact Logs',
                    tooltip: 'Resident Contact Logs',
                    items: []
                },
                {
                    id: `${parentId}_4_3`,
                    parentId: `${parentId}_4`,
                    name: 'COMMUNITY_COMMUNICATION_LOGS',
                    path: '/community/:communityId/communication-logs',
                    icon: '',
                    text: 'Communication Logs',
                    tooltip: 'Communication Logs',
                    items: []
                },
                {
                    id: `${parentId}_4_4`,
                    parentId: `${parentId}_4`,
                    name: 'COMMUNITY_ANNOUNCEMENT_LOGS',
                    path: '/community/:communityId/announcement-logs',
                    icon: '',
                    text: 'Announcement Logs',
                    tooltip: 'Announcement Logs',
                    items: []
                },
                {
                    id: `${parentId}_4_5`,
                    parentId: `${parentId}_4`,
                    name: 'COMMUNITY_MAIL_MERGE',
                    path: '/community/:communityId/mail-merge',
                    icon: '',
                    text: 'Mail Merge',
                    tooltip: 'Mail Merge',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'COMMUNITY_PROPERTY',
            path: null,
            icon: '',
            text: 'Properties',
            tooltip: 'Properties',
            items: [
                {
                    id: `${parentId}_5_1`,
                    parentId: `${parentId}_5`,
                    name: 'COMMUNITY_PROPERTIES',
                    path: '/community-properties/:communityId/home',
                    icon: '',
                    text: 'Property Details',
                    tooltip: 'Property Details',
                    items: []
                },
                {
                    id: `${parentId}_5_2`,
                    parentId: `${parentId}_5`,
                    name: 'COMMUNITY_RESIDENT_DIRECTORY',
                    path: '/community/:communityId/resident-directory',
                    icon: '',
                    text: 'Resident Directory',
                    tooltip: 'Resident Directory',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'COMMUNITY_REPORTS',
            path: null,
            icon: '',
            text: 'Reports',
            tooltip: 'Reports',
            items: [
                {
                    id: `${parentId}_6_1`,
                    parentId,
                    name: 'COMMUNITY_REPORTS_ON_DEMAND',
                    path: '/community/:communityId/reports',
                    icon: '',
                    text: 'On Demand',
                    tooltip: 'On Demand',
                    items: []
                },
                {
                    id: `${parentId}_6_2`,
                    parentId,
                    name: 'COMMUNITY_REPORTS_MOVE_INS',
                    path: '/community/:communityId/reports/move-ins',
                    icon: '',
                    text: 'Move-In Summary',
                    tooltip: 'Move-In Summary',
                    items: []
                },
                {
                    id: `${parentId}_6_3`,
                    parentId,
                    name: 'COMMUNITY_REPORTS_SUMMARY',
                    path: '/community/:communityId/reports/summary',
                    icon: '',
                    text: 'Summary - Previous Month',
                    tooltip: 'Summary - Previous Month',
                    items: []
                }
            ]
        }
    ];

    static propertyCommunityRootItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'COMMUNITY_HOME',
            path: '/community/:communityId/:customerId/home',
            icon: '',
            text: 'Community Workspace',
            tooltip: 'Community Workspace',
            items: [],
            isWorkspace: true
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_COMPLIANCE',
            path: null,
            icon: '',
            text: 'Compliance',
            tooltip: 'Compliance',
            items: [
                {
                    id: `${parentId}_2_1`,
                    parentId: `${parentId}_2`,
                    name: 'COMMUNITY_RESTRICTION_SUMMARY',
                    path: '/community/:communityId/:customerId/community-restriction-summary',
                    icon: '',
                    text: 'Restriction Summary',
                    tooltip: 'Restriction Summary',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'COMMUNITY_INFORMATION',
            path: null,
            icon: '',
            text: 'Information',
            tooltip: 'Information',
            items: [
                {
                    id: `${parentId}_3_1`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_BOARD_OF_DIRECTORS',
                    path: '/community/:communityId/:customerId/board-of-directors',
                    icon: '',
                    text: 'Board Executives',
                    tooltip: 'Board Executives',
                    items: []
                },
                {
                    id: `${parentId}_3_2`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_CALENDAR',
                    path: '/community/:communityId/:customerId/calendar',
                    icon: '',
                    text: 'Calendar',
                    tooltip: 'Calendar',
                    items: []
                },
                {
                    id: `${parentId}_3_3`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_DOCUMENTS',
                    path: null,
                    icon: '',
                    text: 'Documents',
                    tooltip: 'Documents',
                    items: CommunitySideNavigationTree.documentItems(`${parentId}_3_3`, ':communityId/:customerId')
                },
                {
                    id: `${parentId}_3_4`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_DASHBOARD',
                    path: '/community/:communityId/:customerId/dashboard',
                    icon: '',
                    text: 'Graphs & Metrics',
                    tooltip: 'Graphs & Metrics',
                    items: []
                },
                {
                    id: `${parentId}_3_5`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_INFO',
                    path: '/community/:communityId/:customerId/information',
                    icon: '',
                    text: 'Info Summary',
                    tooltip: 'Info Summary',
                    items: []
                },
                {
                    id: `${parentId}_3_6`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_LEGAL_INFO',
                    path: '/community/:communityId/:customerId/legal-information',
                    icon: '',
                    text: 'Legal Summary',
                    tooltip: 'Legal Summary',
                    items: []
                },
                {
                    id: `${parentId}_3_7`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_MAP',
                    path: '/community/:communityId/:customerId/map',
                    icon: '',
                    text: 'Map',
                    tooltip: 'Community Map',
                    items: []
                },
                {
                    id: `${parentId}_3_8`,
                    parentId: `${parentId}_3`,
                    name: 'COMMUNITY_ENFORCEMENT_POLICY',
                    path: '/community/:communityId/:customerId/enforcement-policy',
                    icon: '',
                    text: 'Enforcement Policy',
                    tooltip: 'Enforcement Policy',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'COMMUNITY_COMMUNICATION',
            path: null,
            icon: '',
            text: 'Communications',
            tooltip: 'Communications',
            items: [
                {
                    id: `${parentId}_4_1`,
                    parentId: `${parentId}_4`,
                    name: 'COMMUNITY_MASS_COMMUNICATION',
                    path: '/community/:communityId/:customerId/masscommunication',
                    icon: '',
                    text: 'Mass Communications',
                    tooltip: 'Mass Communications',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'COMMUNITY_PROPERTY',
            path: null,
            icon: '',
            text: 'Properties',
            tooltip: 'Properties',
            items: [
                {
                    id: `${parentId}_5_1`,
                    parentId: `${parentId}_5`,
                    name: 'COMMUNITY_PROPERTIES',
                    path: '/community-properties/:communityId/:customerId/home',
                    icon: '',
                    text: 'Property Details',
                    tooltip: 'Property Details',
                    items: []
                },
                {
                    id: `${parentId}_5_2`,
                    parentId: `${parentId}_5`,
                    name: 'COMMUNITY_RESIDENT_DIRECTORY',
                    path: '/community/:communityId/:customerId/resident-directory',
                    icon: '',
                    text: 'Resident Directory',
                    tooltip: 'Resident Directory',
                    items: []
                }
            ]
        }
    ];

    static documentItems = (parentId: string, context: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'COMMUNITY_DOCUMENT_ARCHIVE',
            path: `/community/${context}/community-documents`,
            icon: '',
            text: 'Archive',
            tooltip: 'Document Archive',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_CLOUD_DRIVE',
            path: `/community/${context}/cloud-drive`,
            icon: '',
            text: 'Cloud Drive',
            tooltip: 'Cloud Drive',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'COMMUNITY_NEW_DOCUMENT_SUMMARY',
            path: `/community/${context}/new-documents-report`,
            icon: '',
            text: 'New Document Summary',
            tooltip: 'New Document Summary',
            items: []
        }
    ];
}
